<template>
  <v-container fluid py-0 px-0 id="order-add-edit">
    <u-i-toolbar-admin :title="titlePage" :icon="icon"/>
    <v-layout align-center py-3 fill-height>
      <v-flex xs12>
        <v-layout align-top py-0>
          <v-flex xs12 sm12 py-0 px-2>
            <v-data-table
              :headers="headers"
              :items="bags"
              :hide-actions="true"
              class="elevation-2"
            >
              <template v-slot:items="props">
                <td
                  class="text-xs-center"
                  style="width: 56px"
                >
                  <v-checkbox
                    v-model="formTotal.ids"
                    :value="props.item.id"
                    flat
                    style="height: 24px;"
                    class="checkbox-ids ma-0"
                    color="info"
                  />
                </td>
                <td class="text-xs-center">#{{ props.item.id }}</td>
                <td class="text-xs-center">{{ props.item.name }}</td>
                <td class="text-xs-center">{{ props.item.created }}</td>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
        <v-layout row wrap py-3>
          <v-flex xs12 sm6 md4 lg2>
            <v-btn @click="goToList" block black>
              Cancel
            </v-btn>
          </v-flex>
          <v-flex xs12 sm6 md4 lg2 pl-2>
            <v-btn @click="saveEdited" black block color="primary" :disabled="!bags.length || !formTotal.ids.length">
              Save
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

import UIToolbarAdmin from '@/components/UI/ToolbarAdmin';
import ReportsFlightsService from '@/services/Admin/ReportsFlights';

export default {
  name: 'ConsolidatedInvoice',
  props: {
    id: {
      required: false,
      type: [String, Number],
      default: 0,
    },
  },
  components: {
    UIToolbarAdmin
  },
  metaInfo() {
    const titleTemplate = `%s - Admin | ${this.titlePage}`
    return {titleTemplate}
  },
  data: () => ({
    formData: {},
    formTotal: {
      ids: [],
      selectedKg: 0,
    },
    isForm: true,
    headers: [
      {
        align: 'center',
        sortable: false,
        class: 'font-weight-bold grey darken-2 white--text',
      },
      {
        text: 'ID',
        value: 'id',
        align: 'center',
        sortable: false,
        class: 'font-weight-bold grey darken-2 white--text'
      },
      {
        text: 'Name',
        value: 'name',
        align: 'center',
        sortable: false,
        class: 'font-weight-bold grey darken-2 white--text'
      },
      {
        text: 'Created',
        value: 'created',
        align: 'center',
        sortable: false,
        class: 'font-weight-bold grey darken-2 white--text',
      }
    ]
  }),
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.getData();
    },
    saveEdited() {
      this.$store.commit('setLoading', true);
      ReportsFlightsService.createBag({flight_id: this.$route.params.id, bag_ids: this.formTotal.ids})
        .then(response => {
          if (response.data.status === this.$response.Ok) {
            this.$store.commit('setSuccess', response.data.message);
            this.goToList();
          }
        })
        .catch(error => {
          if (error.response.status === this.$response.UnprocessableEntity) {
            this.messages = this.$helpers.getProp(error, 'response.messages', {});
            this.scrollToErrorField();
          }
          this.$store.commit('setError', error.response.data.message);
        })
        .finally(() => this.$store.commit('setLoading', false));
    },
    getData() {
      this.$store.commit('setLoading', true);
      ReportsFlightsService.getAvailableBags(this.$route.params.id)
        .then(response => {
          this.formData = this.$helpers.getProp(response, 'data', {});
        })
        .catch(error => {
          this.$store.dispatch('setError', this.$helpers.getProp(error, 'response.data.message', 'Something went wrong!'));
        })
        .finally(() => this.$store.commit('setLoading', false));
    },
    goToList() {
      this.$router.push({name: 'AdminReportsFlightsManageBags', params: {id: this.$route.params.id}});
    },
  },
  computed: {
    bags() {
      return this.$helpers.getProp(this.formData, 'data', []);
    },
    titlePage() {
      return 'Add bags to Flight';
    },
    icon() {
      return 'cases';
    }
  }
}
</script>

<style lang="stylus">
.checkbox-ids {
  .v-input__slot, .v-input--selection-controls__input {
    margin: 0 !important;
  }
}
</style>
